<template>
  <div>
    <!-- FILTROS -->
    <b-card>
      <h2>Filtros</h2>
      <validation-observer ref="formPesquisar">
        <b-form class="mt-2">
          <!-- Filtros Simples -->
          <b-row>
            <b-col md="2">
              <b-form-group label="Pesquisar Por:" label-for="pesquisarPor">
                <b-form-select
                  id="pesquisarPor"
                  :clearable="false"
                  :options="tipoOpcoes"
                  v-model="pesquisar.tipoOpcoes"
                  label="name"
                  class="tw-w-full tw-max-w-md tw-mb-4 tw-rounded-md tw-shadow-sm tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-sm:text-sm"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Descrição" label-for="pesquisar">
                <b-form-input
                  v-if="pesquisar.tipoOpcoes == 1"
                  id="pesquisar"
                  type="text"
                  v-model="pesquisar.descricao"
                  placeholder="Nome"
                  class="form-control cleave-height"
                  :raw="false"
                />
                <cleave
                  v-else-if="pesquisar.tipoOpcoes == 2"
                  id="pesquisar"
                  type="text"
                  v-model="pesquisar.descricao"
                  placeholder="Nº Contrato"
                  class="form-control cleave-height"
                  :raw="false"
                  :options="options.cleaveCodigo"
                />
                <cleave
                  v-else-if="pesquisar.tipoOpcoes == 3"
                  id="pesquisar"
                  type="text"
                  v-model="pesquisar.descricao"
                  placeholder="CPF"
                  class="form-control cleave-height"
                  :raw="false"
                  :options="options.cleaveCPF"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Status" label-for="status">
                <v-select
                  class="custom-selection"
                  id="status"
                  :options="statusOpcoes"
                  v-model="pesquisar.statusOpcoes"
                  name="status"
                  inputId="statusInput"
                  :reduce="(option) => option.value"
                  label="text"
                  :clearable="false"
                  :multiple="true"
                  @input="handleSelectionStatusOpcoes"
                >
                  <template #no-options>
                    <div class="my-no-options-message">Nenhum registro encontrado!</div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Data Inicial" label-for="dataInicial">
                <validation-provider #default="{ errors }" name="Data Inicial">
                  <b-input-group>
                    <cleave
                      id="dataInicial"
                      type="text"
                      v-model="pesquisar.dataInicial"
                      placeholder="DD/MM/AAAA"
                      class="form-control cleave-height"
                      :options="options.cleaveDate"
                      :raw="false"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        size="sm"
                        button-variant="primary"
                        class="datePickerWithInput"
                        right
                        button-only
                        v-model="dataInicialDatePicker"
                        :hide-header="true"
                        :initial-date="new Date()"
                        :state="errors[0] ? false : null"
                        label-help=""
                        label-calendar="Calendário"
                        label-close-button="Fechar"
                        label-current-month="Mês atual"
                        label-next-decade="Próxima década"
                        label-next-month="Próximo mês"
                        label-next-year="Próximo ano"
                        label-prev-decade="Década anterior"
                        label-prev-month="Mês anterior"
                        label-prev-year="Ano anterior"
                        label-select-month="Selecione o mês"
                        label-select-year="Selecione o ano"
                        label-selected="Selecionado"
                        label-no-date-selected="Nenhuma data selecionada"
                        label-reset-button="Resetar"
                        label-today-button="Hoje"
                        label-today="Hoje"
                        locale="pt-br"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                        aria-controls="dataInicial"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Data Final" label-for="dataFinal">
                <validation-provider
                  #default="{ errors }"
                  name="Data Inicial"
                  :rules="{
                    dataPassada: {
                      value: dataFinal,
                      dataParametro: dataInicial,
                      stringParametro: 'data inicial',
                    },
                  }"
                >
                  <b-input-group>
                    <cleave
                      id="dataFinal"
                      type="text"
                      v-model="pesquisar.dataFinal"
                      placeholder="DD/MM/AAAA"
                      class="form-control cleave-height"
                      :options="options.cleaveDate"
                      :raw="false"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        size="sm"
                        button-variant="primary"
                        class="datePickerWithInput"
                        right
                        button-only
                        v-model="dataFinalDatePicker"
                        :hide-header="true"
                        :initial-date="new Date()"
                        :state="errors[0] ? false : null"
                        label-help=""
                        label-calendar="Calendário"
                        label-close-button="Fechar"
                        label-current-month="Mês atual"
                        label-next-decade="Próxima década"
                        label-next-month="Próximo mês"
                        label-next-year="Próximo ano"
                        label-prev-decade="Década anterior"
                        label-prev-month="Mês anterior"
                        label-prev-year="Ano anterior"
                        label-select-month="Selecione o mês"
                        label-select-year="Selecione o ano"
                        label-selected="Selecionado"
                        label-no-date-selected="Nenhuma data selecionada"
                        label-reset-button="Resetar"
                        label-today-button="Hoje"
                        label-today="Hoje"
                        locale="pt-br"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                        aria-controls="dataFinal"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Vendedor" label-for="vendedor">
                <v-select id="vendedor" v-model="pesquisar.usuarioId" :options="vendedores" label="name" :reduce="(option) => option.id" />
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Botões -->
          <b-row align-h="end">
            <b-col md="auto">
              <b-button
                :disabled="isBusy"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                style="margin-top: 21px; width: 160px"
                @click="carregarGrid()"
              >
                {{ !isBusy ? 'Prévia' : '' }}
                <b-spinner small v-if="isBusy" />
              </b-button>
            </b-col>
            <b-col md="auto">
              <template>
                <b-dropdown variant="link" no-caret toggle-class="p-0" left :popper-opts="{ positionFixed: true }">
                  <template #button-content>
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" style="margin-top: 21px; width: 160px">
                      Exportar
                    </b-button>
                  </template>
                  <b-dropdown-item href="#" @click="exportTo('pdf')">
                    <feather-icon icon="FileTextIcon" size="16" />
                    <span class="align-middle ml-50" title="Exportar para PDF">PDF</span>
                  </b-dropdown-item>
                  <b-dropdown-item href="#" @click="exportTo('excel')">
                    <feather-icon icon="CheckCircleIcon" size="16" />
                    <span class="align-middle ml-50" title="Exportar para excel">Excel</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
    <!-- TABELA -->
    <b-card v-if="this.items.length > 0 || isBusy">
      <template v-if="isBusy">
        <div class="text-center my-2">
          <b-spinner class="align-middle mr-1"></b-spinner>
          <strong>Carregando Tabela...</strong>
        </div>
      </template>

      <!-- TOTALIZADORES -->
      <div v-if="!isBusy" v-show="this.items.length > 0">
        <div id="containerTotalizadores" class="mb-1">
          <div class="mr-1">
            Total de Propostas: <b-badge variant="primary"> {{ totalRows }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaAprovado">
            Propostas Aprovadas: <b-badge variant="success"> {{ totalizadores.aprovado }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaPendente">
            Propostas Pendentes: <b-badge variant="warning"> {{ totalizadores.pendente }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaContratoGerado">
            Propostas com Contrato Consolidado: <b-badge variant="success"> {{ totalizadores.contratoGerado }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaNegado">
            Propostas Negadas: <b-badge variant="danger"> {{ totalizadores.negado }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaContratoCancelado">
            Propostas Cancelado : <b-badge variant="danger"> {{ totalizadores.contratoCancelado }}</b-badge>
          </div>

          <div class="mr-1" v-if="apresentaExpirado">
            Propostas Expiradas: <b-badge variant="secondary"> {{ totalizadores.expirado }}</b-badge>
          </div>
        </div>

        <b-row>
          <b-col md="12">
            <div>
              <b-table
                style="overflow-x: auto; -webkit-overflow-scrolling: touch"
                outlined
                foot-clone
                id="tabelaGrid"
                ref="tabelaGrid"
                striped
                :per-page="perPage"
                :current-page="currentPage"
                :fields="fields"
                :items="items"
                responsive="sm"
                class="position-relative custom-rounded-table"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template v-slot:cell(statusProposta)="row">
                  <b-badge v-if="row.item.statusProposta == 'ContratoGerado'" variant="primary"> Contrato Gerado </b-badge>

                  <b-badge v-else-if="row.item.statusProposta == 'Aprovado'" variant="success">
                    {{ row.item.statusProposta }}
                  </b-badge>

                  <b-badge v-else-if="row.item.statusProposta == 'Pendente'" variant="warning">
                    {{ row.item.statusProposta }}
                  </b-badge>

                  <b-badge v-else-if="row.item.statusProposta == 'Negado'" variant="danger">
                    {{ row.item.statusProposta }}
                  </b-badge>

                  <b-badge v-else-if="row.item.statusProposta == 'ContratoCancelado'" variant="secondary"> Contrato Cancelado </b-badge>

                  <b-badge v-else-if="row.item.statusProposta == 'Expirado'" variant="secondary">
                    {{ row.item.statusProposta }}
                  </b-badge>
                </template>

                <!-- Default fall-back custom formatted footer cell -->
                <template #foot()="">
                  {{ '' }}
                </template>
                <template #foot(dataCadastro)="">
                  {{ 'Total: ' }}
                </template>
                <template #foot(valorProposta)="">
                  {{ formatarValor(totalValorProposta) }}
                </template>
                <template #foot(valorParcela)="">
                  {{ formatarValor(totalValorParcela) }}
                </template>
              </b-table>

              <b-card-body v-if="this.items.length > 0" class="d-flex justify-content-between flex-wrap pt-0">
                <!-- page length -->
                <b-form-group
                  style="align-items: center"
                  label="Por Página"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
                </b-form-group>

                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="this.items.length"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-card-body>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <relatorioPropostasPaisagem ref="exportarPDF" :parametro="parametroPDF" />
      </div>
    </b-card>
  </div>
</template>

<script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, dataPassada, valor } from '@validations'
  import { formatarData, formatarParaNumber, formatarValor, formatarValorPorcentagem, formatarValorReais } from '@/libs/utils'
  import Cleave from 'vue-cleave-component'
  import 'cleave.js/dist/addons/cleave-phone.br'
  import Ripple from 'vue-ripple-directive'
  import useJwt from '@/auth/jwt/useJwt'
  import relatorioPropostasPaisagem from './components/relatorioPropostasPaisagem.vue'
  import { VueSelect } from 'vue-select'
  import { generateAndDownloadPdf } from '@/utils/geradorPDF/geradorPDF.js'
  import VueHtml2pdf from 'vue-html2pdf'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import * as XLSX from 'xlsx'
  import vSelect from 'vue-select'

  export default {
    components: {
      valor,
      VueHtml2pdf,
      ToastificationContent,
      formatarValor,
      generateAndDownloadPdf,
      formatarValorReais,
      relatorioPropostasPaisagem,
      useJwt,
      dataPassada,
      formatarData,
      BCardCode,
      ValidationProvider,
      ValidationObserver,
      Cleave,
      VueSelect,
      required,
      vSelect,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        items: [],
        formatarValor,
        valor: 0,
        isBusy: false,
        nomeRelatorio: 'Relatório de Propostas',
        descricao: '',
        statusProposta: { id: `Todos`, name: 'Todos' },
        valorProposta: '',
        valorParcela: '',
        dataCadastro: '',
        taxa: '',
        parcelas: '',
        dataGerado: '',
        proposta: '',
        parametroPDF: {
          dados: [],
          colunas: [],
          totalizadores: { aprovado: 0, pendente: 0, negado: 0, contratoGerado: 0, contratoCancelado: 0, expirado: 0 },
          periodo: { dataInicio: '', dataFim: '' },
        },
        datePicker: {
          dataInicial: '',
          dataFinal: '',
        },
        currentPage: 1,
        perPage: 100,
        pageOptions: [10, 25, 50, 100],
        totalRows: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        tipoOpcoes: [
          { value: 1, text: 'Nome' },
          { value: 2, text: 'Código' },
          { value: 3, text: 'Matrícula' },
        ],
        dataInicialDatePicker: '',
        dataFinalDatePicker: '',
        dataInicial: '',
        dataFinal: '',
        options: {
          cleaveDate: {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
          },
          cleaveCPF: {
            numericOnly: true,
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
          },
          cleaveCodigo: {
            numericOnly: true,
            delimiters: ['/'],
            blocks: [6, 2],
          },
        },
        number: {},
        statusOpcoes: [
          { value: 0, text: 'Todos' },
          { value: 'Pendente/Aprovado', text: 'Pendente/Aprovado' },
          { value: 'Aprovado', text: 'Aprovado' },
          { value: 'Pendente', text: 'Pendente' },
          { value: 'Negado', text: 'Negado' },
          { value: 'ContratoGerado', text: 'Contrato Gerado' },
          { value: 'ContratoCancelado', text: 'Contrato Cancelado' },
          { value: 'Expirado', text: 'Expirado' },
        ],
        fields: [
          {
            id: 'dataCadastro',
            key: 'dataCadastro',
            label: 'Data de Cadastro',
            sortable: true,
          },
          {
            id: 'proposta',
            key: 'proposta',
            label: 'Código',
            sortable: true,
          },
          {
            key: 'segurado.tomador.nomeCompleto',
            label: 'Nome',
            sortable: true,
          },
          {
            id: 'valorProposta',
            key: 'valorProposta',
            label: 'Valor Proposta',
            sortable: true,
          },
          {
            id: 'valorParcela',
            key: 'valorParcela',
            label: 'Valor Parcela',
            sortable: true,
          },
          {
            id: 'taxa',
            key: 'taxa',
            label: 'Taxa',
            sortable: true,
          },
          {
            id: 'parcelas',
            key: 'parcelas',
            label: 'Nº Parcelas',
            sortable: true,
          },
          {
            id: 'statusProposta',
            key: 'statusProposta',
            label: 'Status',
            sortable: true,
          },
          {
            id: 'vendedor',
            key: 'vendedor',
            label: 'Vendedor',
            sortable: true,
            tdClass: 'custom-width',
          },
        ],
        fieldsPdf: [
          {
            id: 'dataCadastro',
            key: 'dataCadastro',
            label: 'Data de Cadastro',
          },
          {
            id: 'proposta',
            key: 'proposta',
            label: 'Código',
          },
          {
            key: 'segurado.tomador.nomeCompleto',
            label: 'Nome',
          },
          {
            id: 'valorProposta',
            key: 'valorProposta',
            label: 'Valor Proposta',
          },
          {
            id: 'valorParcela',
            key: 'valorParcela',
            label: 'Valor Parcela',
          },
          {
            id: 'taxa',
            key: 'taxa',
            label: 'Taxa',
            thStyle: { width: '7%' },
            tdstyle: { width: '7%' },
          },
          {
            id: 'parcelas',
            key: 'parcelas',
            label: 'Nº Parcelas',
            thStyle: { width: '7%' },
            tdstyle: { width: '7%' },
          },
          {
            id: 'statusProposta',
            key: 'statusProposta',
            label: 'Status',
            thStyle: { width: '7%' },
            tdstyle: { width: '7%' },
          },
          {
            id: 'vendedor',
            key: 'vendedor',
            label: 'Vendedor',

            tdClass: 'custom-width',
          },
        ],

        totalizadores: {
          aprovado: 0,
          pendente: 0,
          negado: 0,
          contratoGerado: 0,
          contratoCancelado: 0,
          expirado: 0,

          apresentaAprovado: false,
          apresentaPendente: false,
          apresentaNegado: false,
          apresentaContratoGerado: false,
          apresentaContratoCancelado: false,
          apresentaExpirado: false,
        },
        apresentaAprovado: false,
        apresentaPendente: false,
        apresentaNegado: false,
        apresentaContratoGerado: false,
        apresentaContratoCancelado: false,
        apresentaExpirado: false,
        totalValorProposta: 0,
        totalValorParcela: 0,
        totalParcelas: 0,
        vendedores: [],
        vendedor: null,
        pesquisar: {
          tipoOpcoes: 1,
          descricao: '',
          statusOpcoes: [0],
          dataInicial: null,
          dataFinal: null,
          usuarioId: null,
        },
        previousSelectionStatusOpcoes: [0],
        tipoOpcoes: [
          { value: 1, text: 'Nome' },
          { value: 2, text: 'Matrícula' },
          { value: 3, text: 'Nº Contrato' },
        ],
      }
    },
    mounted() {
      this.carregarVendedores()
    },
    methods: {
      carregarVendedores() {
        useJwt
          .get(`cadastro/user/buscaVendedores`)
          .then((response) => {
            const vendedores = response.data
            this.vendedores = vendedores
          })
          .catch((error) => {
            console.error(error)
          })
      },
      carregarGrid() {
        this.isBusy = true

        useJwt
          .post('proposta/getRelatorio', this.pesquisar)
          .then((response) => {
            if (!response.data.length > 0) this.$message.error('Nenhum registro foi encontrado!')

            this.items = response.data.map((item) => ({
              ...item,
              valorProposta: formatarValorReais(item.valor),
              valorParcela: formatarValorReais(item.valorPrimeiraParcela),
              taxa: formatarValorPorcentagem(item.taxa),
              dataGerado: formatarData(item.dataAprovado),
              dataCadastro: formatarData(item.createdAt),
              statusProposta: item.statusProposta,
              proposta: item.id,
              parcelas: item.parcelas,
              vendedor: item.usuario?.name ?? 'SEM VENDEDOR',
            }))

            this.contabilizaPropostasPorStatus()
            this.totalRows = this.items.length
            this.configuraTotalizadores()

            this.totalValorProposta = this.items.reduce((acc, item) => acc + formatarParaNumber(item.valor), 0)

            this.totalValorParcela = this.items.reduce((acc, item) => acc + formatarParaNumber(item.valorPrimeiraParcela), 0)

            this.totalParcelas = this.items.reduce((acc, item) => acc + formatarParaNumber(item.parcelas), 0)
          })

          .catch((error) => {
            console.error(error)
            this.isBusy = false
          })
          .finally(() => {
            this.isBusy = false
          })
      },

      exportTo(method) {
        if (this.items.length == 0) {
          this.$message.error('Não há dados para exportar!')
          return
        }

        this.parametroPDF = {
          dados: this.items,
          colunas: this.fieldsPdf,
          totalizadores: {
            ...this.totalizadores,
            apresentaAprovado: this.apresentaAprovado,
            apresentaPendente: this.apresentaPendente,
            apresentaNegado: this.apresentaNegado,
            apresentaContratoGerado: this.apresentaContratoGerado,
            apresentaContratoCancelado: this.apresentaContratoCancelado,
            apresentaExpirado: this.apresentaExpirado,
            totalRows: this.totalRows,
            totalValorProposta: this.totalValorProposta,
            totalValorParcela: this.totalValorParcela,
            totalParcelas: this.totalParcelas,
          },

          periodo: {
            dataInicio: this.dataInicial,
            dataFim: this.dataFinal,
          },
        }
        let self = this
        if (method == 'pdf') {
          setTimeout(function () {
            self.exportToPDF()
          }, 3000)
        } else {
          this.exportToExcel()
        }
      },

      exportToPDF() {
        if (this.$refs.tabelaGrid) {
          let htmlContent = this.$refs.exportarPDF.$children[0].$refs.html2PdfLandscape.$el.innerHTML
          let periodoFiltro = `Período: ${this.dataInicial} a ${this.dataFinal}`
          let nomeRelatorio = this.nomeRelatorio
          const relatorioPaisagem = true

          generateAndDownloadPdf(this, htmlContent, periodoFiltro, nomeRelatorio, relatorioPaisagem)
        } else {
          console.error('Elemento da tabela não encontrado')
        }
      },
      exportToExcel() {
        const itemsExcel = this.items.map((item) => ({
          'Data de Cadastro': item.dataCadastro || '',
          Código: String(item.proposta) || '',
          Nome: item.segurado.tomador.nomeCompleto || '',
          'Valor Proposta': item.valorProposta || '',
          'Valor Parcela': item.valorParcela || '',
          Taxa: item.taxa || '',
          'Nº Parcelas': String(item.parcelas) || '',
          Status: item.statusProposta || '',
          Vendedor: item.vendedor || '',
        }))

        const summaryRows = [
          {
            'Data de Cadastro': 'Total  ',
            Código: '',
            Nome: '',
            'Valor Proposta': this.totalValorProposta ? formatarValor(this.totalValorProposta) : '',
            'Valor Parcela': this.totalValorParcela ? formatarValor(this.totalValorParcela) : '',
            Taxa: '',
            'Nº Parcelas': this.totalParcelas || '',
            Status: '',
            Vendedor: '',
          },

          { 'Data de Cadastro': '', Código: '', 'Valor Proposta': '', 'Valor Parcela': '', Taxa: '', 'Nº Parcelas': '', Status: '', Vendedor: '' },
        ]

        // Mapeia os status a serem incluídos
        const statusToInclude = [
          { condition: this.apresentaAprovado, label: 'Propostas Aprovadas', value: this.totalizadores.aprovado },
          { condition: this.apresentaPendente, label: 'Propostas Pendentes', value: this.totalizadores.pendente },
          { condition: this.apresentaNegado, label: 'Propostas Negadas', value: this.totalizadores.negado },
          { condition: this.apresentaContratoGerado, label: 'Propostas com Contrato Consolidado', value: this.totalizadores.contratoGerado },
          { condition: this.apresentaContratoCancelado, label: 'Propostas Canceladas', value: this.totalizadores.contratoCancelado },
          { condition: this.apresentaExpirado, label: 'Propostas Expiradas', value: this.totalizadores.expirado },
        ]

        // Adiciona os status filtrados à lista
        statusToInclude.forEach(({ condition, label, value }) => {
          if (condition) {
            summaryRows.push({
              'Data de Cadastro': label,
              Código: value,
              'Valor Proposta': '',
              'Valor Parcela': '',
              Taxa: '',
              'Nº Parcelas': '',
              Status: '',
              Vendedor: '',
            })
          }
        })

        // Junta os dados principais com os resumos
        const finalData = [...itemsExcel, ...summaryRows]

        // Criando a planilha e adicionando ao workbook
        const ws = XLSX.utils.json_to_sheet(finalData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Relatorio')

        // Salvando o arquivo
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },
      contabilizaPropostasPorStatus() {
        this.totalizadores = this.items.reduce(
          (acc, item) => {
            if (item.statusProposta === 'Aprovado') {
              acc.aprovado += 1
            } else if (item.statusProposta === 'Pendente') {
              acc.pendente += 1
            } else if (item.statusProposta === 'Negado') {
              acc.negado += 1
            } else if (item.statusProposta === 'ContratoGerado') {
              acc.contratoGerado += 1
            } else if (item.statusProposta === 'ContratoCancelado') {
              acc.contratoCancelado += 1
            } else if (item.statusProposta === 'Expirado') {
              acc.expirado += 1
            }
            return acc
          },
          { aprovado: 0, pendente: 0, negado: 0, contratoGerado: 0, contratoCancelado: 0, expirado: 0 },
        )
      },
      configuraTotalizadores() {
        this.apresentaAprovado = false
        this.apresentaPendente = false
        this.apresentaNegado = false
        this.apresentaContratoGerado = false
        this.apresentaContratoCancelado = false
        this.apresentaExpirado = false

        if (this.statusProposta.id == 'Aprovado' || this.statusProposta.id == 'Pendente/Aprovado' || this.statusProposta.id == 'Todos') {
          this.apresentaAprovado = true
        }

        if (this.statusProposta.id == 'Pendente/Aprovado' || this.statusProposta.id == 'Pendente' || this.statusProposta.id == 'Todos') {
          this.apresentaPendente = true
        }

        if (this.statusProposta.id == 'ContratoGerado' || this.statusProposta.id == 'Todos') {
          this.apresentaContratoGerado = true
        }

        if (this.statusProposta.id == 'Negado' || this.statusProposta.id == 'Todos') {
          this.apresentaNegado = true
        }

        if (this.statusProposta.id == 'Expirado' || this.statusProposta.id == 'Todos') {
          this.apresentaExpirado = true
        }

        if (this.statusProposta.id == 'ContratoCancelado' || this.statusProposta.id == 'Todos') {
          this.apresentaContratoCancelado = true
        }

        if (this.statusProposta.id == 'Todos') {
          this.apresentaAprovado = true
          this.apresentaPendente = true
          this.apresentaNegado = true
          this.apresentaContratoGerado = true
          this.apresentaContratoCancelado = true
          this.apresentaExpirado = true
        }
      },

      handleSelectionStatusOpcoes(selected) {
        const added = selected.filter((value) => !this.previousSelectionStatusOpcoes.includes(value))

        if (added.includes(0)) {
          this.pesquisar.statusOpcoes = [0]
        } else if (added.length > 0) {
          this.pesquisar.statusOpcoes = selected.filter((value) => value !== 0)
        }

        this.previousSelectionStatusOpcoes = [...this.pesquisar.statusOpcoes]
      },
    },
    watch: {
      dataInicialDatePicker(newVal) {
        this.pesquisar.dataInicial = formatarData(this.dataInicialDatePicker)
      },
      dataFinalDatePicker(newVal) {
        this.pesquisar.dataFinal = formatarData(this.dataFinalDatePicker)
      },
    },
  }
</script>
<style>
  .custom-width {
    width: 300px;
  }

  #containerTotalizadores {
    display: flex !important;
    flex-wrap: wrap !important;
    flex-direction: row !important;
    align-content: flex-start !important;
  }
</style>
